export const COLOR_RATES = { bw: 3.0, color: 8.0 } as const;

/**
 * The mock's copy says "15% eco discount", but its own math (base * 0.875,
 * i.e. base - base*0.125) is actually 12.5% — that's the number that
 * produces the ₹28.00 total shown in both reference screenshots for
 * 8 pages × 2 copies × ₹2.00/page. Using the real math here, not the copy.
 */
export const DUPLEX_DISCOUNT_RATE = 0.125;

export const STAPLE_FEE_PER_SET = 0.0;

export const PAPER_SIZES = [
  { id: 'a4', label: 'A4 Standard', sub: '210 × 297 mm', priceDelta: 0 },
  { id: 'letter', label: 'Letter', sub: '8.5 × 11 in', priceDelta: 0 },
  { id: 'legal', label: 'Legal Size', sub: '8.5 × 14 in', priceDelta: 1 },
  { id: 'a3', label: 'A3 Poster', sub: '297 × 420 mm', priceDelta: 4 },
] as const;
